import type { LayoutResult } from './layout-mindmap';
import type { ParsedMindmap } from './mindmap-types';

export enum MindmapRenderKind {
  Empty = 'empty',
  Flow = 'flow',
}

export type MindmapRenderModel =
  | { kind: MindmapRenderKind.Empty }
  | { kind: MindmapRenderKind.Flow; layout: LayoutResult };

const EMPTY_MINDMAP_RENDER_MODEL: MindmapRenderModel = {
  kind: MindmapRenderKind.Empty,
};

export function getMindmapRenderModel(input: {
  layout: LayoutResult | null;
  parsed: ParsedMindmap | null;
}): MindmapRenderModel {
  if (!input.parsed) {
    return EMPTY_MINDMAP_RENDER_MODEL;
  }

  if (!input.layout) {
    return EMPTY_MINDMAP_RENDER_MODEL;
  }

  if (input.layout.nodes.length === 0) {
    return EMPTY_MINDMAP_RENDER_MODEL;
  }

  return {
    kind: MindmapRenderKind.Flow,
    layout: input.layout,
  };
}
